export default "__VITE_ASSET__CkVorCjU__"